module.exports = __webpack_public_path__ + "img/capsule-toy-green.86e89422.png";